import React, { useCallback } from 'react';

import {
  Button, Icon, Text, View,
} from '@vectord/ui';

import { gtmEventHandler } from '@common/utils/gtm';
import PlacementReport from '../PlacementReport/index';

const RcbSuccess = ({ checkLaterHandler }) => {
  const handleCheckLaterClick = useCallback(async () => {
    gtmEventHandler(
      'cta',
      'rcb_success_check_later',
      'click',
      'alumni_directory',
    );
    checkLaterHandler(false);
  }, [checkLaterHandler]);

  return (
    <View className="vd-flex-col vd-gap-y-12 vd-px-20
        vd-py-24 sm:vd-px-32 sm:vd-py-32 vd-z-10 vd-bg-surface-neutral-base"
    >
      <View className="vd-flex vd-gap-8 vd-px-20 vd-py-16
          vd-bg-background-alert-success-subtler"
      >
        <Icon
          color="icon-alert-success-soft"
          iconSize="xl"
          name="circle-wavy-check"
          type="fill"
        />
        <View className="vd-flex-col vd-gap-2">
          <Text fontSize="h3" color="text-neutral-primary" weight="semibold">
            Your request received successfully
          </Text>
          <Text fontSize="b3" color="text-neutral-tertiary">
            We’ll get in touch with you within the next 48 Hours.
          </Text>
        </View>
      </View>
      <PlacementReport />
      <Button
        buttonType="text"
        size="m"
        title="I’ll check later"
        upperCase={false}
        variants="neutral"
        onClick={handleCheckLaterClick}
      />
    </View>
  );
};

export default RcbSuccess;
